/* eslint-disable no-console */
import React from "react";
import { Form, Button } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Event } from "../../../../api";
import { useAuth } from "../../../../hooks";

const eventController = new Event();

export function CategoryForm(props) {
  const { onClose, onReload, category } = props;
  const { accessToken } = useAuth();

  const formik = useFormik({
    initialValues: {
      name: category?.name || "",
      description: category?.description || "",
      color: category?.color || "#4CAF50",
      icon: category?.icon || "calendar",
      isActive: category?.isActive !== undefined ? category.isActive : true,
      displayOrder: category?.displayOrder || 1,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("El nombre es obligatorio"),
      color: Yup.string()
        .matches(
          /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/,
          "Debe ser un color hexadecimal válido"
        )
        .required("El color es obligatorio"),
      displayOrder: Yup.number()
        .positive("Debe ser un número positivo")
        .integer("Debe ser un número entero")
        .required("El orden es obligatorio"),
    }),
    validateOnChange: false,
    enableReinitialize: true,
    onSubmit: async (formValue) => {
      try {
        if (!category) {
          await eventController.createEventCategory(accessToken, formValue);
        } else {
          await eventController.updateEventCategory(
            accessToken,
            category.id,
            formValue
          );
        }
        onReload();
        onClose();
      } catch (error) {
        console.error("Error saving category:", error);
      }
    },
  });

  return (
    <Form className="category-form" onSubmit={formik.handleSubmit}>
      <Form.Input
        name="name"
        placeholder="Nombre de la categoría *"
        label="Nombre *"
        onChange={formik.handleChange}
        value={formik.values.name}
        error={formik.errors.name}
      />

      <Form.TextArea
        name="description"
        placeholder="Descripción de la categoría"
        label="Descripción"
        onChange={formik.handleChange}
        value={formik.values.description}
        error={formik.errors.description}
        rows={3}
      />

      <Form.Input
        type="color"
        name="color"
        label="Color *"
        onChange={formik.handleChange}
        value={formik.values.color}
        error={formik.errors.color}
      />
      <Form.Input
        name="icon"
        placeholder="Nombre del icono (ej: calendar)"
        label="Icono"
        onChange={formik.handleChange}
        value={formik.values.icon}
      />

      <Form.Input
        type="number"
        name="displayOrder"
        placeholder="Orden de visualización"
        label="Orden *"
        onChange={formik.handleChange}
        value={formik.values.displayOrder}
        error={formik.errors.displayOrder}
      />
      <Form.Field>
        <label>Estado</label>
        <Form.Checkbox
          label="Activo"
          checked={formik.values.isActive}
          onChange={(e, data) => formik.setFieldValue("isActive", data.checked)}
        />
      </Form.Field>

      <Button type="submit" primary fluid loading={formik.isSubmitting}>
        {!category ? "Crear Categoría" : "Actualizar Categoría"}
      </Button>
    </Form>
  );
}
